import React from 'react';
import { Badge, Box, Group, Text, Flex, Image } from '@chakra-ui/react';


const Header: React.FC = () => (
  <Box as="header" color="white" bg="#18181b" padding="10px">
    <Flex>
      <Box marginRight="10px" alignSelf="center">
        <Image src="/api/static/movielabs-logo-gradient-dark.svg" alt="MovieLabs Logo" style={{ height: '25px' }} />
      </Box>
      <Group marginEnd="auto" alignItems="center">
        <Text fontWeight="bold">OMC Validator</Text>
        <Badge colorPalette="orange" variant="solid">Preview</Badge>
      </Group>
    </Flex>
  </Box>
);

export default Header; 